import { fillBand, fillVar } from "./fill";
import { barPct } from "./portalView";

/** A horizontal bar of a fill percent, with a tick at the projected percent; `coloured` uses the fill band colour (rule U-22). */
export function FillBar({ pct, projected = null, coloured = false }: { pct: number | null; projected?: number | null; coloured?: boolean }) {
  const now = barPct(pct);
  const later = barPct(projected);
  if (now === null && later === null) return null;
  const colour = coloured && pct !== null ? { background: fillVar(fillBand(Math.round(pct))) } : {};
  return (
    <span className="level-bar" aria-hidden="true" data-testid="level-bar">
      {now !== null && <span className="level-bar-now" style={{ width: `${now}%`, ...colour }} />}
      {later !== null && <span className={`level-bar-later${(projected ?? 0) >= 100 ? " full" : ""}`} style={{ left: `${later}%` }} />}
    </span>
  );
}
